import Notification from './notification'

export default class SingleStepNotification extends Notification {
  constructor(transfer, filter) {
    super(transfer, filter)
    this.attachedStepId = null
  }

  get attachedStep() {
    return this.transfer.steps.find(step => step.id === parseInt(this.attachedStepId))
  }

  get isFrontendCompatible() {
    return super.isFrontendCompatible && Boolean(this.attachedStep)
  }

  formatConfigurable(value) {
    return `<span class='configurable'>${value}</span>`
  }
}
